import React, { useState, useContext } from 'react';
import { Send2, Gallery } from 'iconsax-react';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

export default function ShareThoughtsModal({ onClose, isClosing, avatarUrl }) {
  const theme = useContext(ThemeContext);
  const [text, setText] = useState('');

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 210,
        backgroundColor: 'rgba(0,0,0,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: isClosing
          ? 'backdropFadeOut 0.3s ease forwards'
          : 'backdropFadeIn 0.18s ease forwards',
      }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          backgroundColor: theme.cardBg,
          borderRadius: s(30),
          width: s(660),
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          animation: isClosing
            ? 'modalFadeOut 0.3s ease forwards'
            : 'modalSpringIn 0.4s ease forwards',
        }}
      >
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: s(16),
          padding: s(20),
          borderBottom: `1px solid ${theme.border}`,
          flexShrink: 0,
        }}>
          <img
            src={avatarUrl}
            alt="avatar"
            style={{ width: s(44), height: s(44), borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
          />
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: s(8) }}>
            <span
              className="font-satoshi font-bold"
              style={{ fontSize: s(20), lineHeight: `${s(28)}px`, color: theme.text100 }}
            >
              Eda
            </span>
            <div style={{ position: 'relative', display: 'inline-flex' }} className="share-info-wrap">
              <svg width={s(16)} height={s(16)} viewBox="0 0 16 16" fill="none" style={{ cursor: 'default', flexShrink: 0 }}>
                <circle cx="8" cy="8" r="7.25" stroke={theme.text400} strokeWidth="1.5" />
                <path d="M8 7v5" stroke={theme.text400} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="8" cy="5" r="0.75" fill={theme.text400} />
              </svg>
              <style>{`
                .share-info-wrap:hover .share-tooltip { opacity: 1; pointer-events: auto; }
                .share-tooltip {
                  opacity: 0;
                  pointer-events: none;
                  transition: opacity 0.15s;
                  position: absolute;
                  left: 50%;
                  top: calc(100% + 8px);
                  transform: translateX(-50%);
                  background: #303f46;
                  color: #ffffff;
                  font-family: 'Satoshi', sans-serif;
                  font-size: ${s(14)}px;
                  line-height: ${s(20)}px;
                  font-weight: 400;
                  white-space: normal;
                  width: ${s(240)}px;
                  text-align: center;
                  padding: ${s(8)}px ${s(12)}px;
                  border-radius: ${s(10)}px;
                  z-index: 10;
                }
                .share-tooltip::before {
                  content: '';
                  position: absolute;
                  bottom: 100%;
                  left: 50%;
                  transform: translateX(-50%);
                  border: 5px solid transparent;
                  border-bottom-color: #303f46;
                }
              `}</style>
              <span className="share-tooltip">The thoughts would always be posted as a parent profile even if using a kids profile for privacy reasons</span>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <svg width={s(24)} height={s(24)} viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke={theme.modalCloseIcon} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: `${s(16)}px ${s(24)}px`, flexShrink: 0 }}>
          <textarea
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Share your thoughts...."
            style={{
              width: '100%',
              height: s(260),
              border: 'none',
              outline: 'none',
              resize: 'none',
              fontFamily: "'Satoshi', sans-serif",
              fontSize: s(16),
              lineHeight: '1.6',
              color: theme.text100,
              backgroundColor: 'transparent',
              boxSizing: 'border-box',
              letterSpacing: '0.16px',
            }}
          />
        </div>

        {/* Footer */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: s(20),
          flexShrink: 0,
        }}>
          {/* Toolbar */}
          <div style={{ display: 'flex', gap: s(20), alignItems: 'center' }}>
            {/* Emoji */}
            <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}>
              <svg width={s(24)} height={s(24)} viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9.75" stroke={theme.text400} strokeWidth="1.5" />
                <circle cx="9" cy="10.5" r="1" fill={theme.text400} />
                <circle cx="15" cy="10.5" r="1" fill={theme.text400} />
                <path d="M8.5 14.5c.9 1.5 2.1 2 3.5 2s2.6-.5 3.5-2" stroke={theme.text400} strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </button>
            {/* Gallery */}
            <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}>
              <Gallery size={s(24)} variant="Linear" color={theme.text400} />
            </button>
            {/* Attachment / Plus */}
            <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}>
              <svg width={s(24)} height={s(24)} viewBox="0 0 24 24" fill="none">
                <path d="M12 5v14M5 12h14" stroke={theme.text400} strokeWidth="1.8" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          {/* Post button */}
          <button
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: s(12),
              backgroundColor: theme.btnPrimaryBg,
              border: 'none',
              borderRadius: s(12),
              padding: `${s(12)}px ${s(36)}px`,
              cursor: 'pointer',
            }}
          >
            <Send2 size={s(20)} variant="Linear" color={theme.btnPrimaryText} />
            <span
              className="font-satoshi"
              style={{ fontSize: s(16), lineHeight: `${s(24)}px`, fontWeight: 500, color: theme.btnPrimaryText }}
            >
              Post
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
